import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie';

import {useAuth} from '../../hooks/AuthContext';
import { useNavigate } from "react-router-dom";

const ValidateSession = () => {
  const [userToken, setUserToken] = useState('');
  const { setPermissions, logout, setAuth } = useAuth();
  const navigate = useNavigate();
  console.log("ValidateSession");

  useEffect(()=>{

    const authData = Cookies.get('TokenPortal');
    if (authData) {

      const j =JSON.parse(authData.slice(2));
      localStorage.setItem("TokenPortal",j.token);
      localStorage.setItem("User",JSON.stringify(j.userData));
      setAuth({ permissions: j.permissions });
      setPermissions(j.permissions);
      navigate('/app');
    }else{
      console.log("cookie:",authData);
      console.warn('La cookie no está presente');
      navigate('/');
    }

  },[]);


  
  return (
    <>
      
    </>
  )
}

export default ValidateSession
